import 'css-chunksrc/client/common/infiniteScroll/styles.scss';export default {
  "infiniteScroll": "_infiniteScroll_hvi2g_1",
  "content": "_content_hvi2g_8"
};